module.exports = __webpack_public_path__ + "static/media/teams-operations.c74aa64e.svg";